import { UpdateMyAccountData, User } from '../../../../types';
import { ConstructPost } from '../../../types/ConstructPost';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { MIDDLE_OFFICE_BASE_PATH } from '../../constants/middleOfficeBasePath';

export const postUpdateMyAccount = async (
  constructPost: ConstructPost,
  data: UpdateMyAccountData,
): Promise<NonPaginatedResponse<User> | undefined> =>
  constructPost<NonPaginatedResponse<User>>(
    `${MIDDLE_OFFICE_BASE_PATH}/account/update`,
    { data },
    { preventDefaultErrorToast: true },
  );
